var render = function render(){var _vm=this,_c=_vm._self._c;return _c('YLayoutBodyMenu',{attrs:{"aside-width":"8rem","menu":[
    {path:'/user/visitor/mini',title:'小程序访客'},
    {path:'/user/visitor/official',title:'公众号访客'},
    {path:'/user/visitor/official-sub',title:'公众号借权访客'},
]}},[_c('router-view')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }